import {Component, OnDestroy, OnInit} from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AccountPaymentFavoriteDTO, AccountPaymentFavoriteService, TypeEnum } from '@wlp/ui-bs-account-payment-favorite';
import { AccountBalanceService } from '@wlp/ui-bs-cashin';
import { transactionSchedule, TransferResponse, TransferService } from '@wlp/ui-bs-cashout';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { LoadingService } from 'src/app/core/layout/services/loading.service';

import { ModalAlertComponent } from './../../../../../../modals/modal-alert/modal-alert.component';
import { ModalTokenComponent } from './../../../../../../modals/modal-token/modal-token.component';
import { ModalTransferResumeComponent } from './../../../../../../modals/modal-transfer-resume/modal-transfer-resume.component';

@Component({
  selector: 'app-on-us-favorites',
  templateUrl: './on-us-favorites.page.html',
  styleUrls: ['./on-us-favorites.page.scss'],
})
export class OnUsFavoritesPage implements OnInit, OnDestroy {
  public formTransfer: any;
  public errorMessages: any;
  public transferData: any;
  public transferQuestion: string;
  param: object;
  toogleFavorite: boolean;
  selectedFavorite: boolean;

  userProfile: UserInfoProfile;

  private readonly OPERATION: string = '901';
  private readonly RANGE: string = '1';

  private datesSchedule: transactionSchedule;

  constructor(
    private accountBalanceService: AccountBalanceService,
    private navCtrl: NavController,
    private transferService: TransferService,
    private loadingService: LoadingService,
    private modalController: ModalController,
    private layoutConfigService: LayoutConfigService,
    protected userInfoService: UserInfoService,
    private storage: Storage,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService
  ) {
    this.param = { wlName: this.layoutConfigService.getConfig('wlTheme.wlName') };
  }

  public async ngOnInit() {
    this.errorMessages = this.transferService.getFormMessageError();
    this.formTransfer = this.transferService.getFormTransfer();
    this.loadUser();
  }

  public async ngOnDestroy() {
    this.transferData = null;
    this.formTransfer = null;
  }

  public async ionViewWillEnter() {
    this.formTransfer.controls.transferValue.reset();
    this.transferService.setTransferFlow('On-Us');
    await this.storage.remove('typeTransfer');
    this.storage.set('typeTransfer', 'On-Us').then(() => { });
    this.loadData();
  }

  public getImageTag(tag: string) {
    const item: any = this.layoutConfigService.getImagesPages(tag);
    return item.path;
  }

  goBack() {
    this.navCtrl.navigateRoot(['/app/dashboard']);
  }

  ionViewWillUnload() {
    this.navCtrl.navigateRoot(['/app/dashboard']);
  }


  loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();
      userDetails.then((user) => {
        this.userProfile = user;
        // console.log('PROFILE', this.userProfile);
        this.checkDayResource(user.uuidWhiteLabel, this.OPERATION, this.RANGE);
      });
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  public loadData() {
    this.transferService.getSavedFavorite().subscribe((res) => {
      if (res === true) {
        this.selectedFavorite = true;
      } else {
        this.selectedFavorite = false;
      }
    });
    this.transferService.getTransfer().subscribe((res: TransferResponse) => {
      this.transferData = res;
    });
    if (this.transferData) {
      this.param = this.transferData;
      this.transferQuestion = 'CASH_OUT.TRANSFER_VALUE.DESCRIPTION.PRIMARY';
    } else {
      this.transferQuestion = 'CASH_OUT.TRANSFER_VALUE.DESCRIPTION.SECONDARY';
    }
  }

  public typeDocument() {
    if ( this.formTransfer &&  this.formTransfer.get('document').value) {
      const document: string = this.formTransfer.get('document').value;
      if (document.length > 14) {
        return 'CNPJ:';
      } else {
        return 'CPF:';
      }
    } else {
      return '';
    }
  }

  checkValue(value) {
    if (/^0/.test(value)) {
      this.formTransfer.controls.transferValue.reset();
    }

    value = value.replace(/[^0+\w\s]/gi, '');
    value = parseFloat(value);

    if (value < 100) {
      this.formTransfer.controls.transferValue.setErrors({ invalid1: true });
    }
  }

  public checkFormValue() {
    if (this.formTransfer && this.formTransfer.status === 'VALID') {
      return false;
    } else {
      return true;
    }
  }

  public validateOperation() {
    this.formTransfer.controls.typeTransfer.setValue('On-Us');
    this.storage.remove('transferReceipt');
    this.storage.set('transferReceipt', this.formTransfer.getRawValue()).then(() => {});
    this.transferService.setTransfer(this.formTransfer);
    this.saveFavorite(this.toogleFavorite);
    /**
     ** A verificação do saldo está rodando no backend.
     */
    this.goToResume();
  }

  private checkDayResource(uuidWhiteLabel: string, code: string, type: string) {
    this.transferService.checkDayResource(uuidWhiteLabel, code, type).subscribe((res) => {
      this.datesSchedule = res;
    });
  }

  public async goToResume() {
    const modalResume = await this.modalController.create({
      component: ModalTransferResumeComponent,
      cssClass: 'modal-resume',
      componentProps: {
        datesSchedule: this.datesSchedule,
        formTransferData: this.transferData
      },
    });
    modalResume.onDidDismiss().then((data) => {
      if (data['data'] === true) {
        this.token();
        this.loadBalance(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount);
      }
    });

    return await modalResume.present();
  }

  public async token() {
    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        codeOperation: this.OPERATION,
      },
    });
    modalToken.onDidDismiss().then((data) => {
      if (data['data']) {
        this.storage.get('transferReceipt').then(res => {})

        this.sendTransaction(data['role']);
      }
    });
    return await modalToken.present();
  }

  public async sendTransaction(token: string) {
    this.loadingService.show();
    await this.transferService
      .sendTransaction(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount, token)
      .then((res) => {
        const response = res;
        if (response !== null) {
          if (response.isExecuted && !this.transferData.scheduled && !response.approveFlow) {
            this.statusTransaction('success', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.SUCCESS', false, response.scheduled);
            return;
          }
          if (response.isExecuted && this.transferData.scheduled && !response.approveFlow) {
            this.statusTransaction(
              'success',
              'CASH_OUT.TRANSFER_ON_US.MESSAGES.SCHEDULING_SUCCESSFUL',
              false,
              response.scheduled
            );
            return;
          }
          if (response.isExecuted && response.approveFlow) {
            this.statusTransaction(
              'warning-circle',
              'CASH_OUT.TRANSFER_ON_US.MESSAGES.REQUEST_APPROVAL',
              false,
              response.scheduled,
              response.approveFlow
            );
            return;
          }
          if (response.isExecuted === false) {
            switch (response.message) {
              case 'Operação não realizada, tente novamente mais tarde':
                this.statusTransaction('warning-circle', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.FAILED_NOT_EXECUTED', false);
                break;
              case 'Operação fora de horário':
                this.statusTransaction('warning-circle', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.OUT_OF_TIME', false);
                break;
              case 'LIMITE DE OPERAÇÃO EXCEDIDO EXCEDIDO':
                this.notificationLimit();
                break;
              case 'Codigo de operação invalido':
                this.statusTransaction('warning-circle', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.INVALID_CODE', false);
                break;
              default:
                this.statusTransaction('warning-circle', response.message, false);
            }
          } else {
            this.statusTransaction('warning-circle', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.FAILED', false);
          }
        } else {
          this.statusTransaction('warning-circle', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.FAILED', false);
        }
      })
      .catch((err) => {
        this.transferService.getErrorTransfer(err);
        this.statusTransaction('warning-circle', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.FAILED', false);
      });
  }

  public async statusTransaction(status: string, message: string, confirmation?: boolean, scheduled?: boolean, hasApproveFlow?: boolean) {
    this.loadingService.hide();
    const modalSuccess = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: message,
        confirmBtn: 'CASH_OUT.TRANSFER_ON_US.CLOSE',
        confirmation: confirmation,
        translate: true,
      },
      backdropDismiss: false,
    });
    modalSuccess.onDidDismiss().then((data) => {

      switch(status) {
        case "success": 
          if (scheduled === true) {
            this.navCtrl.navigateRoot(['app/charging/transfer/receipt/true']);
          }

          this.navCtrl.navigateRoot(['app/charging/transfer/receipt/false'], {
            queryParams: { typeRoute: 'on-us' },
          })
        break
        case "warning-circle": 
          if (hasApproveFlow) {
            this.navCtrl.navigateRoot("app/approvals/requests")
          }
        break
        default:
          this.navCtrl.navigateRoot('app');
        break
        
      }
 
    });
    return await modalSuccess.present();
  }

  private async notificationLimit() {
    this.loadingService.hide();
    const modalStatus = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-validate-time',
      componentProps: {
        status: 'warning-circle',
        message: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.LIMIT_OPERATION',
        description: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.MESSAGES.LIMIT_OPERATION_DETAILS',
        confirmBtn: 'CASH_OUT.TRANSFER_OTHER_ACCOUNT.BUTTONS.CLOSE',
        confirmation: false,
        translate: true,
      },
      backdropDismiss: false,
    });
    return await modalStatus.present();
  }

  private loadBalance(uuidWL: string, uuidAccount: string): void {
    this.accountBalanceService
      .getBalance(uuidWL, uuidAccount)
      .then((res) => this.accountBalanceService.setBalanceSubject(res.balance))
      .catch((err) => this.accountBalanceService.getErroMessage(err));
  }

  formatAccountBank(digit) {
    if (digit === null) return digit;

    let account = '';
    let count = digit.length;
    let penultimate = count - 2;
    for (let i = 0; i < count; i++) {
      account += digit[i];
      if (i == penultimate) {
        account += '-';
      }
    }
    return account;
  }

  saveFavorite(checked) {
    if (checked) {
      // this.loadingService.show();
      let prepare: AccountPaymentFavoriteDTO;
      prepare = {
        uuidWhiteLabel: this.userProfile.uuidWhiteLabel,
        uuidAccountPayment: this.userProfile.uuidAccount,
        uuidWhiteLabelDestination: this.transferData.uuidWhiteLabelDestination,
        uuidAccountPaymentDestination: this.transferData.uuidAccountPaymentDestination,
        name: this.transferData.name,
        document: this.transferData.document,
        codeBank: this.transferData.bankCode,
        bankName: this.transferData.bank,
        accountNumber: this.transferData.accountNumber,
        agencyNumber: this.transferData.branch,
        typeAccount: this.transferData.accountType,
        zipCode: '',
        address: '',
        addressNumber: '',
        addressComplement: '',
        neighborhood: '',
        city: '',
        state: '',
        country: '',
        uuid: '',
        type: TypeEnum.ON_US,
      };

      this.accountPaymentFavoriteService
        .saveFavorite(prepare)
        .pipe(
          tap((data) => {
            if (data.status) {
              // this.statusTransaction('success', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.SUCCESS_FAVORITES', true);
            } else {
              // this.statusTransaction('failed', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.FAILED_FAVORITES', true);
              // this.toogleFavorite = false;
            }
            // this.loadingService.hide();
          }),
          catchError((_) => {
            // this.loadingService.hide();
            return of(null);
          })
        )
        .subscribe();
    }
  }

}
